import { useEffect, useMemo, useRef, useState } from "react";
import { FiFilter } from "react-icons/fi";
import Badge from "../../../../../components/badge/badge";
import SectionHeader from "../../../../../components/sectionHeader/sectionHeader";
import InputSearch from "../../../../../components/inputs/inputSearch/inputSearch";
import Button from "../../../../../components/button/button";
import { getApiInstance } from "../../../../../utils/api";
import Modal from "../../../../../components/modal/modal";
import InputCheckbox from "../../../../../components/inputs/inputCheckbox/inputCheckbox";
import Input from "../../../../../components/inputs/input/input";
import Table from "../../../../../components/table/table";
import TableEditable from "../../../../../components/tableEditable/tableEditable";
import Notification from "../../../../../components/notification/notification";
import Accordion from "../../../../../components/accordion/accordion";
import Tag from "../../../../../components/tag/tag";
import InputDropdown from "../../../../../components/inputs/inputDropdown/inputDropdown";
import InputDate from "../../../../../components/inputs/inputDate/inputDate";
import { searchByKeywords } from "../../../../../utils/searchUtils";
import { BiExport } from "react-icons/bi";

const categoriasMapping = {
    TiendasTop: "Tiendas Top",
    TiendasLight: "Tiendas Light",
    TiendasLow: "Tiendas Low",
    General: "General",
    Banner: "Banners",
    Senalizacon: "Señalización",
    PositiveStore: "Positive Store",
    MakeUp: "Make Up 400",
};

const estadoLabels = {
    1: "Pendiente de información",
    2: "Informado",
    3: "Proposición de nueva tarifa",
    4: "Rechazada pendiente de revisión",
    5: "Informado después de revisión",
    6: "Aprobada Atlante",
    7: "Aceptado",
    8: "Rechazado",
    9: "Desestimado",
};

const familiaMapping = {
    1: "Mobiliario Central",
    2: "Mobiliario Perimetral",
    3: "Mesas",
    4: "Probadores",
    5: "Caja",
    6: "Dotación",
    7: "Instalaciones",
    8: "Señalética",
    9: "BOH",
};

const estados = [
    { id: 1, label: "Pendiente de información" },
    { id: 2, label: "Informado" },
    { id: 3, label: "Proposición de nueva tarifa" },
    { id: 4, label: "Rechazada pendiente de revisión" },
    { id: 5, label: "Informado después de revisión" },
    { id: 6, label: "Aprobada Atlante" },
    { id: 7, label: "Aceptado" },
    { id: 8, label: "Rechazado" },
    { id: 9, label: "Desestimado" },
];

const estadoDefault = "Sin estado";

export default function HistoricoTarifas({ user }) {
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedSolicitudes, setSelectedSolicitudes] = useState([]);
    const [solicitudes, setSolicitudes] = useState([]);
    const [filterMuebles, setFilterMuebles] = useState([]);
    const [filterProveedor, setFilterProveedor] = useState([]);
    const [filterNombreTarifa, setFilterNombreTarifa] = useState([]);
    const [filterEstado, setFilterEstado] = useState([]);
    const [filterComparativa, setFilterComparativa] = useState([]);
    const [filterCategoria, setFilterCategoria] = useState([]);
    const [filterSubcategoria, setFilterSubcategoria] = useState([]);
    const [filterFechaInformado, setFilterFechaInformado] = useState([]);
    const [filterDiasRestantes, setFilterDiasRestantes] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isFiltersModalOpen, setIsFiltersModalOpen] = useState(false);
    const [editSolicitud, setEditSolicitud] = useState(null);
    const [mueblesOptions, setMueblesOptions] = useState([]);
    const [proveedoresOptions, setProveedoresOptions] = useState([]);
    const [tarifasOptions, setTarifasOptions] = useState([]);
    const [estadosOptions, setEstadosOptions] = useState(estados);
    const [categorias, setCategorias] = useState([]);
    const [subCategorias, setSubcategorias] = useState([]);
    const [usedFilter, setUsedFilter] = useState();
    const [selectedDate, setSelectedDate] = useState("");

    const notificationRef = useRef(null);

    const columnsTarifas = [
        {
            key: "estado",
            label: "Estado",
            render: (row) => {
                let variant;
                const estadoLegible =
                    estadoLabels[row.codEstado] || "Sin estado";

                switch (row.estado) {
                    case 1: // Pendiente
                        if (row.diasRestantes <= 0) {
                            variant = "danger";
                        } else {
                            variant = "default";
                        }
                        break;
                    case 2: // Informado
                        variant = "info";
                        break;
                    case 3: // Proposición de nueva tarifa
                        variant = "info";
                        break;
                    case 4: // Rechazado pendiente revisión
                        variant = "warning";
                        break;
                    case 5: // Informado después de revisión
                        variant = "info";
                        break;
                    case 6: // Revisado pendiente aceptación
                        variant = "success";
                        break;
                    case 7: // Aceptado
                        variant = "success";
                        break;
                    case 8: // Rechazado
                        variant = "danger";
                        break;
                    case 9: // Desestimado
                        variant = "danger";
                        break;
                    default:
                        variant = "default";
                }

                return <Badge label={estadoLegible} variant={variant} />;
            },
            editable: false,
        },
        {
            key: "diasRestantes",
            label: "Días Restantes",
            type: "number",
            editable: false,
            highlightDays: true,
        },
        {
            key: "rutaImagenMueble",
            label: "Imagen",
            render: (row) => (
                <img
                    src={row.rutaImagenMueble || "defaultImage.png"}
                    alt={row.nombreMueble || "Sin nombre"}
                    style={{
                        maxWidth: "48px",
                        maxHeight: "48px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                />
            ),
            editable: false,
        },
        { key: "nombreMueble", label: "Mueble", editable: false },
        { key: "referencia", label: "Referencia", editable: false },
        { key: "medida", label: "Unidad de medida", editable: false },
        { key: "nombreEmpresa", label: "Proveedor", editable: false },
        { key: "nombreTarifa", label: "Nombre tarifa", editable: false },
        {
            key: "comparativa",
            label: "Comparativa",
            editable: false,
            render: (row) => {
                const minPrecioUnidad = Math.min(
                    ...solicitudes
                        .filter(
                            (solicitud) =>
                                solicitud.codMueble === row.codMueble &&
                                solicitud.fechaSolicitud === row.fechaSolicitud
                        )
                        .map((solicitud) => solicitud.precioUnidad || Infinity)
                );
                if (minPrecioUnidad === Infinity || row.precioUnidad === 0) {
                    return "";
                }
                const comparativa = Math.round(
                    ((row.precioUnidad - minPrecioUnidad) / minPrecioUnidad) *
                        100,
                    2
                );
                if (comparativa === 0) {
                    return "Precio más bajo";
                }
                return `${comparativa}%`;
            },
        },
        {
            key: "referenciaTarifaGOI",
            label: "Referencia Tarifa GOI",
            editable: false,
            required: false,
        },
        {
            key: "precioUnidad",
            label: "Precio Unidad",
            type: "number",
            editable: false,
            required: false,
            render: (row) => {
                if (row.precioUnidad === 0) {
                    return "-";
                }
                return `${row.precioUnidad} ${row.simbolo}`;
            },
        },
        {
            key: "comentariosProveedor",
            label: "Comentarios Proveedor",
            type: "number",
            editable: false,
        },
        {
            key: "fechaSolicitud",
            label: "Fecha Solicitud",
            render: (row) => {
                const date = new Date(row.fechaSolicitud);
                return date.toLocaleDateString();
            },
            editable: false,
        },
        { key: "plazo", label: "Plazo", type: "number", editable: false },
        {
            key: "fechaInformado",
            label: "Fecha Informado",
            render: (row) => {
                const date = new Date(row.fechaInformado);
                if (row.fechaInformado === null) {
                    return "";
                }
                return date.toLocaleDateString();
            },
            editable: false,
        },
        {
            key: "showAll",
            label: "Desglosar precios",
            render: (row) => (
                <Button
                    label="Desglosar precios"
                    onClick={() => handleEditSolicitud(row)}
                />
            ),
        },
    ];

    useEffect(() => {
        fetchSolicitudes();
    }, []);

    const fetchSolicitudes = async () => {
        const api = getApiInstance();
        try {
            const response = await api.post(
                `/api/MueblesPrecios/GetMueblesPrecioByProveedorEstados/${user.codEmpresa}`,
                [1, 2, 3, 4, 5, 6, 7, 8, 9]
            );
            setSolicitudes(response.data);
        } catch (error) {
            console.error("Error al obtener las solicitudes:", error);
            setSolicitudes([]);
        }
    };

    const filteredSolicitudes = useMemo(() => {
        let filtered = [...solicitudes]; // sin aplicar búsqueda aquí


        // Filtro por Variante
        if (filterMuebles.length > 0) {
            filtered = filtered.filter((solicitud) =>
                filterMuebles.includes(solicitud.codMueble)
            );
        }

        // Filtro por Proveedor
        if (filterProveedor.length > 0) {
            filtered = filtered.filter((solicitud) =>
                filterProveedor.includes(solicitud.codEmpresa)
            );
        }

        if (filterNombreTarifa.length > 0) {
            filtered = filtered.filter((solicitud) =>
                filterNombreTarifa.includes(solicitud.nombreTarifa)
            );
        }

        // Filtro por Estado
        if (filterEstado.length > 0) {
            filtered = filtered.filter((solicitud) => {
                return filterEstado
                    .map((estado) => estado.id)
                    .includes(solicitud.estado);
            });
        }

        // Filtro por Categoría
        if (filterCategoria.length > 0) {
            filtered = filtered.filter((solicitud) => {
                const categoria =
                    familiaMapping[solicitud.codFamilia] ||
                    familiaMapping[solicitud.codFamiliaProducto] ||
                    solicitud.categoria ||
                    solicitud.nombreCategoria ||
                    solicitud.familia ||
                    solicitud.nombreFamilia;
                return filterCategoria.includes(categoria);
            });
        }

        // Filtro por Subcategoría
        if (filterSubcategoria.length > 0) {
            filtered = filtered.filter((solicitud) => {
                return filterSubcategoria.includes(solicitud.nombreSubfamilia);
            });
        }

        // Filtro por Comparativa
        if (filterComparativa.length > 0) {
            filtered = filtered.filter((solicitud) => {
                const relatedSolicitudes = solicitudes.filter(
                    (s) =>
                        s.codMueble === solicitud.codMueble &&
                        s.fechaSolicitud === solicitud.fechaSolicitud
                );
                const minPrecioUnidad = Math.min(
                    ...relatedSolicitudes.map((s) => s.precioUnidad || Infinity)
                );
                let comparativaTipo = "";
                if (
                    minPrecioUnidad !== Infinity &&
                    solicitud.precioUnidad !== 0
                ) {
                    const calc = Math.round(
                        ((solicitud.precioUnidad - minPrecioUnidad) /
                            minPrecioUnidad) *
                            100
                    );
                    comparativaTipo = calc === 0 ? "bajo" : "diferencia";
                }
                return filterComparativa.includes(comparativaTipo);
            });
        }

        // Filtro por Días Restantes (rango: [min, max])
        if (
            filterDiasRestantes.length === 2 &&
            filterDiasRestantes[0] !== "" &&
            filterDiasRestantes[1] !== ""
        ) {
            const minDias = parseInt(filterDiasRestantes[0], 10);
            const maxDias = parseInt(filterDiasRestantes[1], 10);
            filtered = filtered.filter(
                (solicitud) =>
                    solicitud.diasRestantes >= minDias &&
                    solicitud.diasRestantes <= maxDias
            );
        }

        // Filtro por Fecha Informado (rango: [fechaInicio, fechaFin])
        if (
            filterFechaInformado.length === 2 &&
            filterFechaInformado[0] !== "" &&
            filterFechaInformado[1] !== ""
        ) {
            const startDate = new Date(filterFechaInformado[0]);
            const endDate = new Date(filterFechaInformado[1]);
            filtered = filtered.filter((solicitud) => {
                if (!solicitud.fechaInformado) return false;
                const fecha = new Date(solicitud.fechaInformado);
                return fecha >= startDate && fecha <= endDate;
            });
        }

        return filtered;
    }, [
        searchTerm,
        solicitudes,
        filterMuebles,
        filterProveedor,
        filterNombreTarifa,
        filterEstado,
        filterCategoria,
        filterSubcategoria,
        filterComparativa,
        filterDiasRestantes,
        filterFechaInformado,
    ]);

    const visibleSolicitudes = useMemo(() => {
    return searchByKeywords(filteredSolicitudes, searchTerm, [
        "referencia",
        "nombreMueble",
        "nombreEmpresa",
        "nombreTarifa",
        "comentariosProveedor",
        "referenciaTarifaGOI"
    ]);
}, [filteredSolicitudes, searchTerm]);


    useEffect(() => {
        // Para generar opciones, aplicamos TODOS los filtros excepto el que estamos generando
        const getFilteredDataExcluding = (excludeFilter) => {
            return solicitudes.filter((solicitud) => {
                // Búsqueda por término
                if (searchTerm) {
                    const matchesSearch = Object.values(solicitud).some(
                        (value) =>
                            (value !== null && value !== undefined
                                ? value.toString()
                                : ""
                            )
                                .toLowerCase()
                                .includes(searchTerm.toLowerCase())
                    );
                    if (!matchesSearch) return false;
                }

                // Aplicar todos los filtros EXCEPTO el que estamos excluyendo
                if (excludeFilter !== "mueble" && filterMuebles.length > 0) {
                    if (!filterMuebles.includes(solicitud.codMueble))
                        return false;
                }

                if (
                    excludeFilter !== "proveedor" &&
                    filterProveedor.length > 0
                ) {
                    if (!filterProveedor.includes(solicitud.codEmpresa))
                        return false;
                }

                if (
                    excludeFilter !== "nombreTarifa" &&
                    filterNombreTarifa.length > 0
                ) {
                    if (!filterNombreTarifa.includes(solicitud.nombreTarifa))
                        return false;
                }

                if (excludeFilter !== "estado" && filterEstado.length > 0) {
                    const estadoIds = filterEstado.map((estado) => estado.id);
                    if (!estadoIds.includes(solicitud.estado)) return false;
                }

                if (
                    excludeFilter !== "categoria" &&
                    filterCategoria.length > 0
                ) {
                    const categoria =
                        familiaMapping[solicitud.codFamilia] ||
                        familiaMapping[solicitud.codFamiliaProducto] ||
                        solicitud.categoria ||
                        solicitud.nombreCategoria ||
                        solicitud.familia ||
                        solicitud.nombreFamilia;
                    if (!filterCategoria.includes(categoria)) return false;
                }

                if (
                    excludeFilter !== "subcategoria" &&
                    filterSubcategoria.length > 0
                ) {
                    if (
                        !filterSubcategoria.includes(solicitud.nombreSubfamilia)
                    )
                        return false;
                }

                // Estos filtros siempre se aplican
                if (filterComparativa.length > 0) {
                    const relatedSolicitudes = solicitudes.filter(
                        (s) =>
                            s.codMueble === solicitud.codMueble &&
                            s.fechaSolicitud === solicitud.fechaSolicitud
                    );
                    const minPrecioUnidad = Math.min(
                        ...relatedSolicitudes.map(
                            (s) => s.precioUnidad || Infinity
                        )
                    );
                    let comparativaTipo = "";
                    if (
                        minPrecioUnidad !== Infinity &&
                        solicitud.precioUnidad !== 0
                    ) {
                        const calc = Math.round(
                            ((solicitud.precioUnidad - minPrecioUnidad) /
                                minPrecioUnidad) *
                                100
                        );
                        comparativaTipo = calc === 0 ? "bajo" : "diferencia";
                    }
                    if (!filterComparativa.includes(comparativaTipo))
                        return false;
                }

                if (
                    filterDiasRestantes.length === 2 &&
                    filterDiasRestantes[0] !== "" &&
                    filterDiasRestantes[1] !== ""
                ) {
                    const minDias = parseInt(filterDiasRestantes[0], 10);
                    const maxDias = parseInt(filterDiasRestantes[1], 10);
                    if (
                        !(
                            solicitud.diasRestantes >= minDias &&
                            solicitud.diasRestantes <= maxDias
                        )
                    )
                        return false;
                }

                if (
                    filterFechaInformado.length === 2 &&
                    filterFechaInformado[0] !== "" &&
                    filterFechaInformado[1] !== ""
                ) {
                    if (!solicitud.fechaInformado) return false;
                    const startDate = new Date(filterFechaInformado[0]);
                    const endDate = new Date(filterFechaInformado[1]);
                    const fecha = new Date(solicitud.fechaInformado);
                    if (!(fecha >= startDate && fecha <= endDate)) return false;
                }

                return true;
            });
        };

        const dataForMuebles = getFilteredDataExcluding("mueble");
        setMueblesOptions(
            Array.from(
                new Map(
                    dataForMuebles.map((solicitud) => [
                        solicitud.codMueble,
                        {
                            id: solicitud.codMueble,
                            nombre: solicitud.referencia,
                        },
                    ])
                ).values()
            )
        );

        const dataForProveedores = getFilteredDataExcluding("proveedor");
        setProveedoresOptions(
            Array.from(
                new Map(
                    dataForProveedores.map((solicitud) => [
                        solicitud.codEmpresa,
                        {
                            id: solicitud.codEmpresa,
                            nombre: solicitud.nombreEmpresa,
                        },
                    ])
                ).values()
            )
        );

        const dataForTarifas = getFilteredDataExcluding("nombreTarifa");
        setTarifasOptions(
            Array.from(
                new Map(
                    dataForTarifas.map((solicitud) => [
                        solicitud.nombreTarifa,
                        {
                            id: solicitud.nombreTarifa,
                            nombre: solicitud.nombreTarifa,
                        },
                    ])
                ).values()
            )
        );

        const dataForEstados = getFilteredDataExcluding("estado");
        setEstadosOptions(
            Array.from(
                new Map(
                    dataForEstados.map((solicitud) => [
                        solicitud.estado,
                        {
                            id: solicitud.estado,
                            nombre: estados.find(
                                (estado) => estado.id === solicitud.estado
                            ).label,
                        },
                    ])
                ).values()
            )
        );

        const dataForCategorias = getFilteredDataExcluding("categoria");
        const allCategorias = dataForCategorias
            .map((solicitud) => {
                return (
                    familiaMapping[solicitud.codFamilia] ||
                    familiaMapping[solicitud.codFamiliaProducto] ||
                    solicitud.categoria ||
                    solicitud.nombreCategoria ||
                    solicitud.familia ||
                    solicitud.nombreFamilia
                );
            })
            .filter(
                (value, index, self) =>
                    value &&
                    value !== null &&
                    value !== undefined &&
                    self.indexOf(value) === index
            )
            .sort(); // Ordenar alfabéticamente para consistencia
        setCategorias(allCategorias);

        const dataForSubcategorias = getFilteredDataExcluding("subcategoria");
        const allSubcategorias = dataForSubcategorias
            .map((solicitud) => solicitud.nombreSubfamilia)
            .filter(
                (value, index, self) =>
                    value &&
                    value !== null &&
                    value !== undefined &&
                    self.indexOf(value) === index
            )
            .sort(); // Ordenar alfabéticamente para consistencia
        setSubcategorias(allSubcategorias);
    }, [
        searchTerm,
        filterMuebles,
        filterProveedor,
        filterNombreTarifa,
        filterEstado,
        filterCategoria,
        filterSubcategoria,
        filterComparativa,
        filterDiasRestantes,
        filterFechaInformado,
        solicitudes,
    ]);

    // useEffect separado solo para la carga inicial de categorías y subcategorías
    useEffect(() => {
        if (
            solicitudes.length > 0 &&
            categorias.length === 0 &&
            subCategorias.length === 0
        ) {
            const allCategorias = solicitudes
                .map((solicitud) => {
                    return (
                        familiaMapping[solicitud.codFamilia] ||
                        familiaMapping[solicitud.codFamiliaProducto] ||
                        solicitud.categoria ||
                        solicitud.nombreCategoria ||
                        solicitud.familia ||
                        solicitud.nombreFamilia
                    );
                })
                .filter(
                    (value, index, self) =>
                        value &&
                        value !== null &&
                        value !== undefined &&
                        self.indexOf(value) === index
                );

            const allSubcategorias = solicitudes
                .map((solicitud) => solicitud.nombreSubfamilia)
                .filter(
                    (value, index, self) =>
                        value &&
                        value !== null &&
                        value !== undefined &&
                        self.indexOf(value) === index
                );

            setCategorias(allCategorias);
            setSubcategorias(allSubcategorias);
        }
    }, [solicitudes, categorias.length, subCategorias.length]);

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const handleEditSolicitud = (solicitud) => {
        setEditSolicitud({
            prototipo: solicitud.prototipo,
            precioUnidadIgnifugo: solicitud.precioUnidadIgnifugo,
            precioMasivo: solicitud.precioMasivo,
            cantidadPedidoMasivo: solicitud.cantidadPedidoMasivo,
            costeFabricacion: solicitud.costeFabricacion,
            costeMateriales: solicitud.costeMateriales,
            costeMaquinaria: solicitud.costeMaquinaria,
            costeManoObra: solicitud.costeManoObra,
            porcentajeBeneficioSobreCoste:
                solicitud.porcentajeBeneficioSobreCoste,
        });
        setIsModalOpen(true);
    };

    const handleSelectComparativa = (option) => {
        setFilterComparativa([option.value]);
    };

    const handleChangeDiasRestantes = (index, value) => {
        const newRange = [...filterDiasRestantes];
        newRange[index] = value;
        setFilterDiasRestantes(newRange);
    };

    const handleChangeFechaInformado = (index, value) => {
        const newDates = [...filterFechaInformado];
        newDates[index] = value;
        setFilterFechaInformado(newDates);
    };

    const handleSelectedMueble = (selectedIds) => {
        setUsedFilter("mueble");
        setFilterMuebles(selectedIds);
    };

    const handleSelectProveedor = (selectedIds) => {
        setUsedFilter("proveedor");
        setFilterProveedor(selectedIds);
    };

    const handleSelectNombreTarifa = (selectedIds) => {
        setUsedFilter("nombreTarifa");
        setFilterNombreTarifa(selectedIds);
    };

    const handleSelectEstado = (estadoName) => {
        setUsedFilter("estado");
        setFilterEstado((prevSelected) => {
            // Verificar si el estado ya está en la lista
            if (prevSelected.includes(estadoName)) {
                // Si ya está en la lista, eliminarla
                return prevSelected.filter((estado) => estado !== estadoName);
            } else {
                // Si no está, agregarla
                return [...prevSelected, estadoName];
            }
        });
    };

    const handleSelectCategoria = (categoriaName) => {
        setUsedFilter("categoria");
        setFilterCategoria((prevSelected) => {
            if (prevSelected.includes(categoriaName)) {
                return prevSelected.filter(
                    (categoria) => categoria !== categoriaName
                );
            } else {
                return [...prevSelected, categoriaName];
            }
        });
    };

    const handleSelectSubcategoria = (subcategoriaName) => {
        setUsedFilter("subcategoria");
        setFilterSubcategoria((prevSelected) => {
            if (prevSelected.includes(subcategoriaName)) {
                return prevSelected.filter(
                    (subcategoria) => subcategoria !== subcategoriaName
                );
            } else {
                return [...prevSelected, subcategoriaName];
            }
        });
    };

    const handleCleanFilter = () => {
        setFilterMuebles([]);
        setFilterProveedor([]);
        setFilterNombreTarifa([]);
        setFilterEstado([]);
        setFilterCategoria([]);
        setFilterSubcategoria([]);
        setFilterComparativa([]);
        setFilterDiasRestantes([]);
        setFilterFechaInformado([]);
    };

    const handleEnviarInformes = async (codEstado) => {
        const api = getApiInstance();
        try {
            if (selectedSolicitudes.length > 0) {
                // Se envía el listado en el body y se pasa codEstado como query string
                const response = await api.put(
                    `/api/MueblesPrecios/update-estados?codEstado=${codEstado}&codEmpresa=${user.codEmpresa}`,
                    selectedSolicitudes
                );

                const { rowsUpdated } = response.data;
                notificationRef.current.addNotification(
                    "Solicitudes actualizadas correctamente.",
                    "success"
                );

                if (selectedSolicitudes.length === rowsUpdated) {
                    setSolicitudes((prevSolicitudes) =>
                        prevSolicitudes.filter(
                            (solicitud) =>
                                !selectedSolicitudes.includes(
                                    solicitud.codPrecioMueble
                                )
                        )
                    );
                }
                fetchSolicitudes();
            }
        } catch (error) {
            console.error("Error en actualización masiva:", error);
            notificationRef.current.addNotification(
                "Hubo un error al actualizar la solicitud.",
                "error"
            );
        }
    };

    const handleExportExcel = async () => {
            try {
                const api = getApiInstance();
                const response = await api.post(
                    `/api/MueblesPrecios/ExportarMisTarifasPendientesExcel/${user.codEmpresa}`,
                    selectedSolicitudes,
                    { responseType: "blob" }
                );
    
                if (response.status !== 200) {
                    throw new Error("Error al descargar el archivo");
                }
    
                // Se obtiene el blob (archivo binario) del response
                const blob = await response.data;
    
                // Se crea un objeto URL para el blob
                const url = window.URL.createObjectURL(blob);
    
                // Se crea un enlace temporal para simular el click y forzar la descarga
                const a = document.createElement("a");
                a.href = url;
    
                // Intenta extraer el nombre de archivo desde el header Content-Disposition
                let fileName = "MisTarifasPendientes.xlsx";
                const disposition = response.headers.get("Content-Disposition");
                if (disposition && disposition.indexOf("filename=") !== -1) {
                    const fileNameMatch = disposition.match(/filename="?([^"]+)"?/);
                    if (fileNameMatch && fileNameMatch.length > 1) {
                        fileName = fileNameMatch[1];
                    }
                }
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
    
                // Se elimina el enlace y se revoca el objeto URL para liberar memoria
                a.remove();
                window.URL.revokeObjectURL(url);
    
                notificationRef.current.addNotification(
                    "Archivo descargado correctamente.",
                    "success"
                );
            } catch (error) {
                notificationRef.current.addNotification(
                    "Error al descargar el archivo.",
                    "error"
                );
                console.error("Error al descargar el archivo:", error);
            }
        };

    return (
        <section className="dashboard-usuarios">
            <div className="dashboard-usuarios__content__table-header">
                <InputSearch
                    context="tableSearch"
                    placeholder="Buscar..."
                    onSearch={setSearchTerm}
                />
                <div className="dashboard-productos__content__table-header__buttons">
                    <Button
                        label="Exportar"
                        variant="outline"
                        icon={<BiExport />}
                        onClick={handleExportExcel}
                        disabled={selectedSolicitudes.length === 0}
                    />
                    <Button
                        variant="outline"
                        label="Filtros"
                        icon={<FiFilter />}
                        onClick={() => setIsFiltersModalOpen(true)}
                    />
                    {user.codTipoEmpresa === 1 && (
                        <Button
                            variant="filled"
                            label="Pasar a desestimado"
                            icon={<FiFilter />}
                            onClick={() => handleEnviarInformes(9)}
                        />
                    )}
                </div>
            </div>

            <TableEditable
                data={visibleSolicitudes}
                columns={columnsTarifas}
                rowKey="codPrecioMueble"
                onRowSelect={setSelectedSolicitudes}
                selectedRows={selectedSolicitudes}
                notificationRef={notificationRef}
                noResultsMessage="No hay solicitudes de tarifas pendientes."
                statesRestrictEdit={[1, 2, 3, 4, 5, 6, 9]}
                showHeaderCheckbox={user.codTipoEmpresa !== 2}
            />

            <Modal
                title="Filtros"
                isOpen={isFiltersModalOpen}
                onClose={() => setIsFiltersModalOpen(false)}
                onAccept={() => setIsFiltersModalOpen(false)}
                outlineButtonLabel="Limpiar"
                primaryButtonLabel={`Ver resultados (${filteredSolicitudes.length})`}
                onCancel={handleCleanFilter}
            >
                <div className="modal-inputs">
                    <div className="section-header__modal__section">
                        <InputDropdown
                            label="Mueble"
                            options={mueblesOptions.map((mueble) => ({
                                label: mueble.nombre,
                                value: mueble.id,
                            }))}
                            onSelect={handleSelectedMueble}
                            withCheckboxes={true}
                            hasSearch={true}
                        />
                    </div>
                    <div className="section-header__modal__section">
                        <InputDropdown
                            label="Proveedor"
                            options={proveedoresOptions.map((proveedor) => ({
                                label: proveedor.nombre,
                                value: proveedor.id,
                            }))}
                            onSelect={handleSelectProveedor}
                            withCheckboxes={true}
                            hasSearch={true}
                        />
                    </div>
                    <div className="section-header__modal__section">
                        <InputDropdown
                            label="Nombre Tarifa"
                            options={tarifasOptions.map((tarifa) => ({
                                label: tarifa.nombre,
                                value: tarifa.id,
                            }))}
                            onSelect={handleSelectNombreTarifa}
                            withCheckboxes={true}
                            hasSearch={true}
                        />
                    </div>

                    <div className="section-header__modal__section">
                        <Accordion title="Categoría">
                            <ul className="section-header__modal__section__content">
                                {categorias.map((categoria, index) => (
                                    <Tag
                                        key={index}
                                        label={categoria}
                                        isSelected={filterCategoria.includes(
                                            categoria
                                        )}
                                        onSelect={handleSelectCategoria}
                                    />
                                ))}
                            </ul>
                        </Accordion>
                    </div>

                    <div className="section-header__modal__section">
                        <Accordion title="Subcategoría">
                            <ul className="section-header__modal__section__content">
                                {subCategorias.map((subcategoria, index) => (
                                    <Tag
                                        key={index}
                                        label={subcategoria}
                                        isSelected={filterSubcategoria.includes(
                                            subcategoria
                                        )}
                                        onSelect={handleSelectSubcategoria}
                                    />
                                ))}
                            </ul>
                        </Accordion>
                    </div>

                    <div className="section-header__modal__section">
                        <Accordion title="Estado">
                            <ul className="section-header__modal__section__content">
                                {estadosOptions.map((estado) => (
                                    <Tag
                                        key={estado.id}
                                        label={estado.nombre}
                                        isSelected={filterEstado.includes(
                                            estado
                                        )}
                                        onSelect={() =>
                                            handleSelectEstado(estado)
                                        }
                                    />
                                ))}
                            </ul>
                        </Accordion>
                    </div>
                    {/* <div className="section-header__modal__section">
                    <InputDropdown
                        label="Comparativa"
                        options={[
                            { label: "Precio más bajo", value: "bajo" },
                            { label: "Diferencia porcentual", value: "diferencia" }
                        ]}
                        onSelect={handleSelectComparativa}
                        withCheckboxes={false}
                        hasSearch={false}
                    />
                </div> */}
                    {/* <div className="section-header__modal__section">
                    <Input
                        label="Días Restantes (mínimo)"
                        type="number"
                        placeholder="Min"
                        value={filterDiasRestantes[0] || ""}
                        onChange={(e) => handleChangeDiasRestantes(0, e.target.value)}
                    />
                    <Input
                        label="Días Restantes (máximo)"
                        type="number"
                        placeholder="Max"
                        value={filterDiasRestantes[1] || ""}
                        onChange={(e) => handleChangeDiasRestantes(1, e.target.value)}
                    />
                </div> */}
                    {/* <div className="section-header__modal__section">
                    <Input
                        label="Fecha Informado - Desde"
                        type="date"
                        value={filterFechaInformado[0] || ""}
                        onChange={(e) => handleChangeFechaInformado(0, e.target.value)}
                    />
                    <Input
                        label="Fecha Informado - Hasta"
                        type="date"
                        value={filterFechaInformado[1] || ""}
                        onChange={(e) => handleChangeFechaInformado(1, e.target.value)}
                    />
                </div> */}
                </div>
            </Modal>

            <Modal
                title="Precios desglosados"
                isOpen={isModalOpen}
                onClose={closeModal}
                outlineButtonLabel="Cancelar"
            >
                <div className="dashboard-usuarios__modal">
                    <form
                        className="dashboard-usuarios__modal__content"
                        autoComplete="off"
                    >
                        <p
                            style={{
                                fontSize: "14px",
                                borderBottom: "1px solid #e0e0e0",
                                paddingBottom: "8px",
                            }}
                        >
                            <strong>Prototipo: </strong>
                            {editSolicitud?.prototipo}
                        </p>
                        <p
                            style={{
                                fontSize: "14px",
                                borderBottom: "1px solid #e0e0e0",
                                paddingBottom: "8px",
                            }}
                        >
                            <strong>Precio unidad ignífugo: </strong>
                            {editSolicitud?.precioUnidadIgnifugo}
                        </p>
                        <p
                            style={{
                                fontSize: "14px",
                                borderBottom: "1px solid #e0e0e0",
                                paddingBottom: "8px",
                            }}
                        >
                            <strong>Precio masivo: </strong>
                            {editSolicitud?.precioMasivo}
                        </p>
                        <p
                            style={{
                                fontSize: "14px",
                                borderBottom: "1px solid #e0e0e0",
                                paddingBottom: "8px",
                            }}
                        >
                            <strong>Cantidad pedido masivo: </strong>
                            {editSolicitud?.cantidadPedidoMasivo}
                        </p>
                        <p
                            style={{
                                fontSize: "14px",
                                borderBottom: "1px solid #e0e0e0",
                                paddingBottom: "8px",
                            }}
                        >
                            <strong>Coste fabricación: </strong>
                            {editSolicitud?.costeFabricacion}
                        </p>

                        <p
                            style={{
                                fontSize: "14px",
                                borderBottom: "1px solid #e0e0e0",
                                paddingBottom: "8px",
                            }}
                        >
                            <strong>Coste materiales: </strong>
                            {editSolicitud?.costeMateriales}
                        </p>
                        <p
                            style={{
                                fontSize: "14px",
                                borderBottom: "1px solid #e0e0e0",
                                paddingBottom: "8px",
                            }}
                        >
                            <strong>Coste maquinaria: </strong>
                            {editSolicitud?.costeMaquinaria}
                        </p>
                        <p
                            style={{
                                fontSize: "14px",
                                borderBottom: "1px solid #e0e0e0",
                                paddingBottom: "8px",
                            }}
                        >
                            <strong>Coste mano de obra: </strong>
                            {editSolicitud?.costeManoObra}
                        </p>
                        <p
                            style={{
                                fontSize: "14px",
                                borderBottom: "1px solid #e0e0e0",
                                paddingBottom: "8px",
                            }}
                        >
                            <strong>Porcentaje beneficio sobre coste: </strong>
                            {editSolicitud?.porcentajeBeneficioSobreCoste}
                        </p>
                    </form>
                </div>
            </Modal>
            <Notification ref={notificationRef} />
        </section>
    );
}
